export default __webpack_public_path__ + "static/media/total_unresolved.ca900b97.svg";